import type { QueuedChangeFailureEvents } from 'shared/channels/entity';
import { defineChannelContract } from 'shared/channels';
import type {
  CreateChecklistAnswerRequest,
  DeleteChecklistAnswerRequest,
  EditChecklistAnswerRequest,
} from 'shared/domain/messages/checklistAnswer/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ChecklistItemAnswerInDto } from 'shared/dtos/in/template';

/** Checklist answer events, each with the change's `uniqueId`. */
export type ChecklistAnswerEvents = QueuedChangeFailureEvents & {
  [DomainMessagesTypes.checklistAnswerCreated]: ChecklistItemAnswerInDto;
  [DomainMessagesTypes.checklistAnswerUpdated]: ChecklistItemAnswerInDto;
  [DomainMessagesTypes.checklistAnswerDeleted]: { _id: string };
};

/** Checklist answer changes; each resolves once queued, its outcome follows as an event. */
export type ChecklistAnswerRequests = {
  create: { request: CreateChecklistAnswerRequest; response: void };
  edit: { request: EditChecklistAnswerRequest; response: void };
  remove: { request: DeleteChecklistAnswerRequest; response: void };
};

export const checklistAnswerContract = defineChannelContract<{
  requests: ChecklistAnswerRequests;
  events: ChecklistAnswerEvents;
}>('checklistAnswerChannel');
